var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 8 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#95C11F",
    d: "M3.573 9.491C1.1 5.772.642 5.391.642 4.023c0-1.872 1.462-3.39 3.267-3.39s3.267 1.518 3.267 3.39c0 1.367-.46 1.749-2.932 5.468a.4.4 0 0 1-.671 0m.336-4.055c.751 0 1.36-.633 1.36-1.413S4.66 2.611 3.91 2.611s-1.362.632-1.362 1.412.61 1.413 1.362 1.413"
  })));
};
export default SvgPin;